import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { OfflineOrderOutboxRepository } from '@asm/features/sync/repositories/offline-order-outbox.repository';
import { OfflineOrderOutboxEntry } from '@asm/features/sync/models/offline-order-sync.model';
import { ASM_CUSTOMER_ID_KEY, ASM_UNIT_ID_KEY } from '@shared/tools/constants';

@Injectable({ providedIn: 'root' })
export class OfflineOrderOutboxState {
  private readonly repo = inject(OfflineOrderOutboxRepository);

  private readonly _entries = signal<OfflineOrderOutboxEntry[]>([]);

  /** Todas as entradas visíveis do outbox (não reconciliadas) */
  readonly entries = this._entries.asReadonly();

  /** Entradas enviáveis: PENDING + FAILED */
  readonly sendableEntries = computed(() =>
    this._entries().filter(e => e.status === 'PENDING' || e.status === 'FAILED'),
  );

  /** Contagem de envios pendentes — substitui orderHistoryRepo.getPending().length */
  readonly pendingCount = computed(() => this.sendableEntries().length);

  /** Entradas em andamento: qualquer estado não completamente reconciliado */
  readonly inProgressEntries = computed(() => this._entries().filter(e => !e.remoteObserved));

  /** Atualiza o estado local relendo o IndexedDB */
  async refresh(): Promise<void> {
    try {
      const b2bUnitUid = localStorage.getItem(ASM_UNIT_ID_KEY) ?? '';
      const customerUid = localStorage.getItem(ASM_CUSTOMER_ID_KEY) ?? '';
      const entries = await firstValueFrom(this.repo.getVisibleForUnit(b2bUnitUid, customerUid));
      this._entries.set(entries);
    } catch (err) {
      // Logar erro mas não substituir entries por [] — distingue "erro" de "fila vazia"
      console.error('[OfflineOrderOutboxState] Erro ao carregar outbox:', err);
    }
  }
}
